export default "__VITE_ASSET__eb3f5d42__"